var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import classNames from "classnames";
import { debounce } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import styles from "../statics/styles/spoiler-scss";
import { SPOILER_TYPE } from "../types";
import SpoilerContainer from "./SpoilerContainer";
const Overlay = ({ hideOverlay, pluginType }) => !hideOverlay ? /* @__PURE__ */ React.createElement(
  "div",
  {
    role: "none",
    className: pluginType === "Gallery" ? styles.overlay_gallery : styles.overlay
  }
) : null;
Overlay.propTypes = {
  hideOverlay: PropTypes.bool,
  pluginType: PropTypes.string
};
class BlockSpoilerComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "onResizeElement", () => {
      this.forceUpdate();
    });
    __publicField(this, "handleClick", (e) => {
      const { onClick } = this.props;
      const { isReveal } = this.state;
      isReveal && onClick?.(e);
    });
    __publicField(this, "onRevealSpoiler", (e) => {
      const { helpers, pluginType } = this.props;
      e.preventDefault();
      this.setState({ isReveal: true });
      helpers.onViewerAction?.(SPOILER_TYPE, "Click", `reveal_${pluginType}`);
    });
    __publicField(this, "renderSpoilerContainer", () => {
      const { isReveal } = this.state;
      const {
        disabledRevealSpoilerBtn,
        setFocusToBlock,
        componentData,
        pluginType,
        setInPluginEditingMode,
        handleButtonContentChange,
        handleDescriptionChange,
        isMobile,
        t,
        helpers
      } = this.props;
      const width = this.elementRef?.offsetWidth;
      const height = this.elementRef?.offsetHeight;
      return !isReveal && /* @__PURE__ */ React.createElement(
        SpoilerContainer,
        {
          styles,
          width,
          height,
          setInPluginEditingMode,
          setFocusToBlock,
          pluginType,
          description: componentData?.config?.spoiler?.description,
          buttonContent: componentData?.config?.spoiler?.buttonContent,
          onRevealSpoiler: !disabledRevealSpoilerBtn ? this.onRevealSpoiler : void 0,
          handleButtonContentChange,
          handleDescriptionChange,
          isMobile,
          t,
          helpers
        }
      );
    });
    __publicField(this, "onKeyDown", (e) => {
      if (e.key === "Enter") {
        this.handleClick(e);
      }
    });
    __publicField(this, "setRef", (ref) => this.elementRef = ref);
    this.state = {};
  }
  componentDidMount() {
    if (window?.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(debounce(this.onResizeElement, 60));
      this.resizeObserver?.observe(this.elementRef);
    }
  }
  componentWillUnmount() {
    if (window?.ResizeObserver) {
      this.resizeObserver?.unobserve(this.elementRef);
    }
  }
  render() {
    const { children, pluginType, width, isMobile } = this.props;
    const { isReveal } = this.state;
    let className = "";
    let blur = "";
    if (!isReveal) {
      const isGallery = pluginType === "Gallery";
      className = isGallery ? styles.hideBlock_gallery : styles.hideBlock;
      if (!isGallery) {
        const width2 = this.elementRef?.offsetWidth;
        blur = width2 < 400 ? styles.smallBlur : width2 < 700 ? styles.mediumBlur : styles.largeBlur;
      }
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.setRef,
        className: classNames(styles.spoilerWrapper, this.props.className, {
          [styles.isMobile]: isMobile
        }),
        style: { width },
        "data-hook": "spoilerContainer"
      },
      this.renderSpoilerContainer(),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(className, blur),
          onClick: this.handleClick,
          role: "button",
          tabIndex: 0,
          onKeyDown: this.onKeyDown
        },
        children,
        /* @__PURE__ */ React.createElement(Overlay, { hideOverlay: isReveal, pluginType })
      )
    );
  }
}
BlockSpoilerComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  theme: PropTypes.object,
  disabledRevealSpoilerBtn: PropTypes.bool,
  isEditableText: PropTypes.bool,
  pluginType: PropTypes.string,
  onClick: PropTypes.func,
  handleDescriptionChange: PropTypes.func,
  handleButtonContentChange: PropTypes.func,
  className: PropTypes.string,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func,
  width: PropTypes.object,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  helpers: PropTypes.object,
  type: PropTypes.string
};
var BlockSpoilerComponent_default = BlockSpoilerComponent;
export {
  BlockSpoilerComponent_default as default
};
//# sourceMappingURL=BlockSpoilerComponent.js.map
